import { Component, OnInit } from '@angular/core';
import { ReportService } from '../services/report.service';
import { AdminService } from '../../admin/services/admin.service';
import { Dealer } from '../../shared/models/dealer.interface';
import { AbstractBiditComponent } from '../../shared/controls/abstract.bidit.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { RolePermission } from '../../shared/models/role.permission.enum';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ListComponent extends AbstractBiditComponent implements OnInit {
  pageTitle: string = "Reports";
  isIDIAdmio: boolean = false;
  quoteOnly: boolean = false;
  canViewBidLog: boolean = false;
  canViewCustomerQuoteContract: boolean = false;
  canViewQuotesByLeadSource: boolean = false;
  canViewLostQuoteAnalysis: boolean = false;
  canViewJobCost: boolean = false;
  canViewInventory: boolean = false;
  canViewPayrollSummary: boolean = false;
  canViewEmailLog: boolean = false;
  canViewSMSLog: boolean = false;



  constructor(deviceDetectorService: DeviceDetectorService, protected reportService: ReportService, private adminService: AdminService) { super(deviceDetectorService) }

  ngOnInit(): void {
    this.isIDIAdmio = (ReportService._authNavStatusSource.value == "IDI");
    this.quoteOnly = (ReportService._authUserSource.value.isQuoteOnly);
    this.canViewBidLog = ReportService.hasPermission(RolePermission.BidLog);
    this.canViewCustomerQuoteContract = ReportService.hasPermission(RolePermission.CustQuoteContract);
    this.canViewQuotesByLeadSource = ReportService.hasPermission(RolePermission.QuotesLeadsSource)

    this.canViewLostQuoteAnalysis = ReportService.hasPermission(RolePermission.LostQuoteAnalysis)
    this.canViewJobCost = ReportService.hasPermission(RolePermission.JobCost)
    this.canViewInventory = ReportService.hasPermission(RolePermission.Inventory)
    this.canViewPayrollSummary = ReportService.hasPermission(RolePermission.PayrollSummary)
    this.canViewEmailLog = ReportService.hasPermission(RolePermission.EmailLog)
    this.canViewSMSLog = ReportService.hasPermission(RolePermission.SMSLog)
  }

}
